import { WebViewerInstance } from '@pdftron/webviewer';
import { useCallback, useEffect } from 'react';

export const useToggleShowExtractions = ({
  instance,
  isShowAllExtractionsChecked,
  onToggleShowAllExtractions,
}: {
  instance: WebViewerInstance | null;
  isShowAllExtractionsChecked?: boolean;
  onToggleShowAllExtractions?: () => void;
}) => {
  const addToggleShowExtractions = useCallback(
    (isChecked: boolean, handleChange: () => void) => {
      if (!instance) return;

      const { UI } = instance;

      const toggleElement = new UI.Components.CustomElement({
        dataElement: 'extractionsToggle',
        className: 'extractions-toggle-custom-element',
        render: () => {
          const container = document.createElement('div');

          const label = document.createElement('span');
          label.textContent = 'Extractions';

          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.checked = Boolean(isChecked);

          checkbox.addEventListener('change', handleChange);

          container.appendChild(label);
          container.appendChild(checkbox);

          return container;
        },
      });

      const defaultHeader = UI.getModularHeader('default-top-header');
      const currentItems = defaultHeader.getItems();

      // Remove existing extractions toggle and divider if they exist
      const existingItems = currentItems.filter(
        (item: unknown) =>
          (item as { dataElement?: string }).dataElement !==
            'extractionsToggle' &&
          (item as { dataElement?: string }).dataElement !==
            'extractionsToggleDivider',
      );

      // Add divider before toggle
      const newDivider = {
        type: 'divider',
        dataElement: 'extractionsToggleDivider',
        hidden: ['mobile'],
      };

      // Place after search button if present, else push to end
      const searchButtonIndex = existingItems.findIndex(
        (item: unknown) =>
          (item as { dataElement?: string }).dataElement ===
          'searchPanelToggle',
      );

      if (searchButtonIndex !== -1) {
        existingItems.splice(
          searchButtonIndex + 1,
          0,
          newDivider,
          toggleElement,
        );
      } else {
        existingItems.push(newDivider);
        existingItems.push(toggleElement);
      }

      // NOTE: This may log warnings in the console similarly to useUnitsPicker
      defaultHeader.setItems(existingItems);
    },
    [instance],
  );

  // Add the extractions toggle to the WebViewer header
  useEffect(() => {
    if (instance && onToggleShowAllExtractions) {
      addToggleShowExtractions(
        Boolean(isShowAllExtractionsChecked),
        onToggleShowAllExtractions,
      );
    }
  }, [
    instance,
    isShowAllExtractionsChecked,
    onToggleShowAllExtractions,
    addToggleShowExtractions,
  ]);
};
